import React from "react";
import Button from "@components/Button";
import { Navigate, useLocation } from "react-router";
import notFoundIcon from "./img/404.svg";
import SectionHeader from "@components/SectionHeader";
import SideBySideLayout from "@components/SideBySideLayout";
import MobileImage from "./img/not-found-mobile.jpg";
import "./style.scss";

export default function NotFoundPage() {
  const { pathname } = useLocation();

  if (pathname !== "/404") {
    return <Navigate to="/404" replace={true} />;
  }

  return (
    <SideBySideLayout
      position="center"
      bgImageMobile={MobileImage}
      bgImageDesktop={MobileImage}
    >
      <div className="not-found-page-content">
        <div className="hero-container">
          <div className="hero-wrapper">
            <div className="info-text">
              <SectionHeader>
                <strong>Die seite existiert nicht</strong>
              </SectionHeader>
            </div>
          </div>
        </div>
        <div className="main-content">
          <img className="info-icon" src={notFoundIcon} alt="info-icon" />
          <p className="header">Oops...</p>
          <p className="sub-header">
            Leider wirst du die seite, nach der du suchst, hier nicht finden.
            Wir helfen dir,
            <strong> wieder auf den Weg zu deiner Homepage zu kommen.</strong>
          </p>
          <Button href="/">Homepage</Button>
        </div>
      </div>
    </SideBySideLayout>
  );
}
